{
  "add": "Add an agent",
  "addFirst": "Add the first agent",
  "emptyTitle": "No agents yet",
  "emptyHint": "An agent is installed once in the site network and connects to the platform with an outbound connection. No port forwarding, no VPN, and no public IP are needed, and nothing is installed on the managed machines.",
  "loadFailed": "Could not load the agents",
  "loadFailedHint": "{{reason}} Check the connection to the server.",
  "editAria": "Edit agent {{name}}",
  "editTitle": "Edit the name and the sites",
  "updateAria": "Update agent {{name}}",
  "deleteAria": "Delete agent {{name}}",
  "deleteTitle": "Delete the agent",
  "deleteConfirm": "Delete agent “{{name}}”? Its sites will be left without an agent, and their nodes reachable only directly.",
  "rotateConfirm": "Issue a new token for “{{name}}”? The previous access is revoked and a running agent disconnects.",
  "pickAgent": "Pick an agent to see its install command and test the tunnel.",
  "noSites": "no sites",
  "column": {
    "name": "Agent",
    "platform": "Platform",
    "version": "Version",
    "update": "Update",
    "sites": "Sites",
    "lastSeen": "Contact"
  },
  "info": {
    "label": "About agents and builds",
    "onePerSite": "An agent connects on its own with an outbound connection. It can serve several sites at once when they share one network; two agents on one site are not allowed — they would run the same checks twice.",
    "catalogAvailable": "The build catalog is available, latest is {{version}}.",
    "catalogMissing": "Auto-update is not configured: the platform cannot reach the agent build catalog, so agents have to be updated by hand."
  },
  "update": {
    "failed": "did not update to {{version}}",
    "disabled": "updates off",
    "behind": "behind: {{version}} available",
    "behindDisabled": "{{version}} available, updates off",
    "current": "up to date",
    "currentDisabled": "up to date, updates off"
  },
  "updateNow": {
    "offline": "The agent is not connected: nothing to update",
    "noCatalog": "The agent build catalog is not configured",
    "upToDate": "The agent already runs the required version",
    "action": "Update to {{version}} now"
  },
  "status": {
    "online": "Connected",
    "offline": "Not connected",
    "never": "Never connected"
  },
  "lastSeen": {
    "never": "never connected",
    "live": "connected"
  },
  "form": {
    "name": "Agent name",
    "nameHint": "as it appears in the list",
    "nameHintNew": "as it will appear in the list",
    "sites": "Sites",
    "siteTaken": "Already served by agent “{{name}}”",
    "pickSites": "— pick the sites —",
    "sitesHintNew": "several can be checked",
    "noSitesYet": "No sites yet",
    "autoUpdate": "Update automatically",
    "autoUpdateHint": "The platform offers an update when a newer version appears in the build catalog. Updating mid-shift is a decision for the administrator",
    "movingNote": "The agent will take over the monitors of the checked sites and stop serving the unchecked ones. The connection is not interrupted."
  },
  "install": {
    "title": "Installing agent {{name}}",
    "intro": "An agent is installed once in the site network and connects with an outbound connection. Nothing has to be installed on the managed machines.",
    "tokenTitle": "One-time token · shown once",
    "tokenShownOnce": "The token was shown at creation time and is no longer stored in the clear.",
    "alreadyEnrolled": "The agent is already enrolled. A new token is only needed for a reinstall.",
    "issuing": "Issuing…",
    "issueToken": "Issue a new token",
    "rotateNote": "The previous access is revoked and a running agent disconnects.",
    "commandTitle": "Install command · {{platform}}",
    "copyCommand": "Copy the command",
    "tokenPlaceholder": "<one-time-token>",
    "download": {
      "title": "Files to install",
      "agent": "Download agent {{version}} · {{size, bytes}}",
      "script": "Download the install script",
      "working": "Downloading…",
      "unavailable": "The platform has no build for this target: the release catalogue is empty or was built without it. Obtain the binary from whoever supplies the platform.",
      "platform": {
        "linux/amd64": "Linux · x86-64",
        "linux/arm64": "Linux · ARM64",
        "windows/amd64": "Windows · x64"
      }
    }
  },
  "probe": {
    "title": "Tunnel check",
    "host": "Device address",
    "port": "Port",
    "test": "Test",
    "testing": "Testing…",
    "offline": "the agent is not connected — the check is unavailable",
    "connecting": "opening the connection…",
    "ok": "connected in {{ms}} ms",
    "hint": "address and port of a device on the site network"
  }
}
